(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-foundation"]) return;
  try {
    
(()=>{
  const root=document.body.dataset.root||'/';
  const url=path=>root+path;
  const $=(q,c=document)=>c.querySelector(q);
  const $$=(q,c=document)=>[...c.querySelectorAll(q)];
  const dialogs=new WeakMap();
  const openDialog=(dialog,trigger)=>{if(!dialog)return;dialogs.set(dialog,trigger);dialog.showModal();};
  const closeDialog=dialog=>{dialog.close();dialogs.get(dialog)?.focus();};
  const announce=message=>{const node=$('[data-announcement]');if(node)node.textContent=message;};
  const json=async(response)=>{let data;try{data=await response.json();}catch{throw new Error('The store could not complete this request. Please try again.');}if(!response.ok)throw new Error(data.description||data.message||'Please try again.');return data;};
  const refreshCart=async()=>{
    const response=await fetch(url('?section_id=q-cart-drawer'));
    if(!response.ok)throw new Error('Your cart was updated. Open the cart page to review it.');
    const html=await response.text();
    const parsed=new DOMParser().parseFromString(html,'text/html');
    const fresh=$('#QCart',parsed);const current=$('#QCart');
    if(!fresh||!current)throw new Error('Open the cart page to review your items.');
    const wasOpen=current.open;const lastTrigger=dialogs.get(current);
    current.innerHTML=fresh.innerHTML;
    const count=$('[data-cart-count]',fresh)?.textContent||'0';
    $$('[data-cart-count]').forEach(n=>n.textContent=count);
    if(wasOpen)dialogs.set(current,lastTrigger);
    return current;
  };
  document.addEventListener('click',async event=>{
    const trigger=event.target.closest('button,a');if(!trigger)return;
    if(trigger.matches('[data-menu-open]'))openDialog($('#QMenu'),trigger);
    if(trigger.matches('[data-dialog-close]'))closeDialog(trigger.closest('dialog'));
    if(trigger.matches('[data-cart-open]')&&document.body.dataset.externalCart!=='true'){event.preventDefault();openDialog($('#QCart'),trigger);}
    if(trigger.matches('[data-gallery-index]')){
      const gallery=trigger.closest('.q-product-gallery');
      $$('[data-gallery-slide]',gallery).forEach(n=>n.hidden=n.dataset.gallerySlide!==trigger.dataset.galleryIndex);
      $$('[data-gallery-index]',gallery).forEach(n=>n.setAttribute('aria-pressed',String(n===trigger)));
    }
    if(trigger.matches('[data-quantity-change]')){
      const input=$('input',trigger.parentElement);input.value=Math.max(1,(Number(input.value)||1)+Number(trigger.dataset.quantityChange));input.dispatchEvent(new Event('change',{bubbles:true}));
    }
    if(trigger.matches('[data-scroll-product]')){$('[data-product-section]')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});$('.q-add')?.focus({preventScroll:true});}
    if(trigger.matches('[data-remove-key]')&&trigger.closest('#QCart')){
      event.preventDefault();trigger.setAttribute('aria-busy','true');
      try{await json(await fetch(url('cart/change.js'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:trigger.dataset.removeKey,quantity:0})}));await refreshCart();$('#QCart [data-dialog-close]')?.focus();announce('Item removed from your cart.');}
      catch(error){const node=$('[data-cart-error]',trigger.closest('dialog'));if(node)node.textContent=error.message;}
      finally{trigger.removeAttribute('aria-busy');}
    }
  });
  document.addEventListener('submit',async event=>{
    const form=event.target;if(!form.matches('.q-product-form')||document.body.dataset.externalCart==='true')return;
    event.preventDefault();const button=$('[name=add]',form);const error=$('[data-form-error]',form);error.textContent='';button.disabled=true;button.setAttribute('aria-busy','true');
    try{await json(await fetch(url('cart/add.js'),{method:'POST',body:new FormData(form)}));const cart=await refreshCart();openDialog(cart,button);announce('Added to your cart.');document.dispatchEvent(new CustomEvent('cart:updated'));}
    catch(e){error.textContent=e.message;}
    finally{button.disabled=false;button.removeAttribute('aria-busy');}
  });
  document.addEventListener('change',async event=>{
    const node=event.target;
    if(node.matches('[data-sort]'))node.form.requestSubmit();
    if(node.matches('[data-cart-key]')&&node.closest('#QCart')){
      const value=Number(node.value);if(!Number.isInteger(value)||value<0){node.reportValidity();return;}
      const error=$('[data-cart-error]',node.closest('dialog'));node.disabled=true;
      try{await json(await fetch(url('cart/change.js'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:node.dataset.cartKey,quantity:value})}));await refreshCart();$('#QCart [data-dialog-close]')?.focus();announce('Cart updated.');}
      catch(e){if(error)error.textContent=e.message;node.disabled=false;}
    }
    if(node.matches('[data-variant]')){
      const section=node.closest('[data-product-section]');const variants=JSON.parse($('[data-variants]')?.textContent||'[]');const variant=variants.find(v=>String(v.id)===node.value);
      if(variant){const price=$('[data-price]',section);const currency=document.documentElement.lang||'en';price.textContent=new Intl.NumberFormat(currency,{style:'currency',currency:document.body.dataset.currency||'USD'}).format(variant.price/100);$('[name=add]',section).disabled=!variant.available;}
    }
  });
  const initialize=()=>{
    $$('dialog').forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='true';dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)closeDialog(dialog);}});dialog.addEventListener('cancel',()=>dialogs.get(dialog)?.focus());});
    const product=$('[data-product-section]'),sticky=$('.q-sticky-product');
    if(product&&sticky&&!product.dataset.observed){product.dataset.observed='true';new IntersectionObserver(entries=>{sticky.classList.toggle('is-visible',!entries[0].isIntersecting&&entries[0].boundingClientRect.top<0);},{rootMargin:'-80px 0px 0px 0px'}).observe(product);}
  };
  initialize();document.addEventListener('shopify:section:load',initialize);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-how-it-works"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const start=root=>{
    if(root.dataset.hiwReady)return;root.dataset.hiwReady='true';
    const steps=[...root.querySelectorAll('[data-hiw-step]')],pills=[...root.querySelectorAll('[data-hiw-pill]')],svg=root.querySelector('svg');
    if(!steps.length)return;
    if(matchMedia('(prefers-reduced-motion: reduce)').matches){svg?.pauseAnimations?.();return;}
    const dur=Number(root.dataset.duration)||3000;let i=-1;
    const go=()=>{
      i=(i+1)%(steps.length+1);
      if(i===steps.length){steps.forEach(s=>s.classList.remove('is-active','is-done'));pills.forEach(p=>p.classList.remove('is-active'));setTimeout(go,600);return;}
      steps.forEach((s,n)=>{s.classList.toggle('is-done',n<i);s.classList.toggle('is-active',n===i);});
      pills.forEach((p,n)=>p.classList.toggle('is-active',n===i));
      setTimeout(go,dur);
    };
    new IntersectionObserver((entries,observer)=>{if(entries[0].isIntersecting){observer.disconnect();root.classList.add('is-running');go();}},{threshold:.3}).observe(root);
  };
  const init=()=>document.querySelectorAll('[data-hiw]').forEach(start);
  init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-product"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const pad=n=>String(n).padStart(2,'0');
  const start=()=>document.querySelectorAll('[data-offer-timer]').forEach(el=>{
    if(el.dataset.ready)return;el.dataset.ready='true';
    const out=el.querySelector('[data-offer-time]'),hour=Number(el.dataset.hour)||12;
    const nextEnd=()=>{const now=new Date(),end=new Date(now);end.setHours(hour,0,0,0);if(end<=now)end.setDate(end.getDate()+1);return end;};
    let end=nextEnd();
    const tick=()=>{let ms=end-Date.now();if(ms<=0){end=nextEnd();ms=end-Date.now();}const t=Math.floor(ms/1000);out.innerHTML='<b>'+pad(Math.floor(t/3600))+'</b><i>:</i><b>'+pad(Math.floor(t%3600/60))+'</b><i>:</i><b>'+pad(t%60)+'</b>';};
    tick();setInterval(tick,1000);el.classList.add('is-ready');
  });
  start();document.addEventListener('shopify:section:load',start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-reviews"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const init=()=>document.querySelectorAll('[data-reviews]').forEach(root=>{
    if(root.dataset.ready)return;root.dataset.ready='1';
    const track=root.querySelector('[data-reviews-track]'),prev=root.querySelector('[data-reviews-prev]'),next=root.querySelector('[data-reviews-next]');
    if(!track)return;
    const step=()=>{const c=track.querySelector('.q-review-card');return c?c.getBoundingClientRect().width+18:track.clientWidth*0.8;};
    const update=()=>{const max=track.scrollWidth-track.clientWidth-4;if(prev)prev.disabled=track.scrollLeft<=4;if(next)next.disabled=track.scrollLeft>=max;};
    prev&&prev.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:'smooth'}));
    next&&next.addEventListener('click',()=>track.scrollBy({left:step(),behavior:'smooth'}));
    track.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update);update();
    let down=false,startX=0,startLeft=0,moved=false;
    track.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse')return;down=true;moved=false;startX=e.clientX;startLeft=track.scrollLeft;});
    window.addEventListener('pointermove',e=>{if(!down)return;const dx=e.clientX-startX;if(Math.abs(dx)>4){moved=true;track.classList.add('is-dragging');track.style.scrollBehavior='auto';}track.scrollLeft=startLeft-dx;});
    window.addEventListener('pointerup',()=>{if(!down)return;down=false;track.classList.remove('is-dragging');track.style.scrollBehavior='';if(moved){const s=step();track.scrollTo({left:Math.round(track.scrollLeft/s)*s,behavior:'smooth'});}});
  });
  init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
